export const TRANSFER_TYPES = {
    Pickup: 'pickup',
    Dropoff: 'dropoff',
};

export const FLUID_TYPES = {
    ProcessedFluid: 'ProcessedFluid',
    RawMilk: 'RawMilk',
};
